import { buildOrdersPagerView } from './ordersPagerView';

/* ============================================================
   ListPager — 4171ba09: shared pager control for the paginated
   order cabinets (customer OrdersPage + provider queue). Pure
   display over the ordersPagerView model; navigation intent is
   the parent's concern (offset state lives there). Light theme,
   iOS-18 minimal per DESIGN-SYSTEM.md.
   ============================================================ */

export function ListPager({
  total,
  offset,
  limit,
  onPrev,
  onNext,
}: {
  total: number;
  offset: number;
  limit: number;
  onPrev: () => void;
  onNext: () => void;
}) {
  const view = buildOrdersPagerView(total, offset, limit);
  if (total <= limit && offset === 0) return null; // single page — no chrome

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-md)',
        flexWrap: 'wrap',
        padding: 'var(--space-xs) 0',
      }}
    >
      <button
        className="btn btn-tertiary"
        style={{ height: 36, padding: '6px 16px' }}
        disabled={!view.hasPrev}
        onClick={onPrev}
      >
        ← Назад
      </button>
      <span style={{ fontSize: 'var(--fs-caption)', color: 'var(--color-text-secondary)' }}>
        {view.from === 0
          ? `Страница ${view.page} из ${view.pageCount}`
          : `Показано ${view.from}–${view.to} из ${total} · стр. ${view.page} из ${view.pageCount}`}
      </span>
      <button
        className="btn btn-tertiary"
        style={{ height: 36, padding: '6px 16px' }}
        disabled={!view.hasNext}
        onClick={onNext}
      >
        Далее →
      </button>
    </div>
  );
}
